/**
 * @author Vivek Kumar <vivek.kumar@314ecorp.com>
 * @description Shared popover for payment list overlays
 */
import { Card, List, Popover } from 'antd';

interface IProps {
	title: string;
	items: React.ReactNode[];
	children: React.ReactElement;
	listItemClassName?: string;
}

const PaymentListTooltip: React.FC<IProps> = ({ title, items, children, listItemClassName }) => {
	return (
		<Popover
			placement='right'
			arrow
			classNames={{ body: 'w-[300px] p-0' }}
			content={
				<Card
					title={title}
					variant='borderless'
					className='flex max-h-[360px] flex-col overflow-hidden'
					classNames={{ header: 'shrink-0 py-2', body: 'min-h-0 flex-1 overflow-y-auto p-0' }}
				>
					<List
						size='small'
						dataSource={items}
						renderItem={(item) => <List.Item className={listItemClassName}>{item}</List.Item>}
					/>
				</Card>
			}
		>
			{children}
		</Popover>
	);
};

export default PaymentListTooltip;
